export default __webpack_public_path__ + "static/media/empty-state-hours.25d2490a.svg";